import gql from 'graphql-tag';

export default gql`
  query Query($callId: ID!, $accessToken: String!) {
    generateS3Url(callId: $callId, accessToken: $accessToken)
  }
`;
